<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialog"
    width="700px"
    style="text-align:left;"
    :close-on-click-modal="false"
    append-to-body
    class="big"
    :show-close="false"
  >
    <div class="content">
      <div>
        <el-input
          v-model="keywords"
          placeholder="请输入商品"
          maxlength="20"
          style="width:200px"
        ></el-input>
        <el-button
          type="primary"
          @click="getList"
          style="margin-left:20px"
        >查询</el-button>
      </div>

      <div class="table_list">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%; "
          :header-cell-style="{ background: '#F5F5F5' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
          >
          </el-table-column>
          <el-table-column
            label="商品"
            width="340"
          >
            <template slot-scope="scope">
              <div
                class="flex between"
                style="width: 300px"
              >
                <el-image
                  :src="scope.row.picture"
                  :preview-src-list="[scope.row.picture]"
                  style="width: 100px; height: 100px"
                />
                <div style="width: 180px">
                  <div>{{ scope.row.goods_name }}</div>
                  <div style="color:#EA6528">¥ {{scope.row.price}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="integral_price"
            label="可积分兑换金额"
            width="140px"
          />
          <el-table-column
            prop="stock"
            label="库存"
          />
        </el-table>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="close"
        plain
      >取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      keywords: '',
      dialog: true,
      page: 1,
      total: 0,
      list: [],
      selection: []
    };
  },
  mounted() {
    this.getList();
  },
  props: {
    act_id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getList() {
      let data = {
        act_id: this.act_id,
        keywords: this.keywords,
        type: 3,
        pageNumber: 1000
      };
      this.axios
        .post('platform/shop/getShopActivityGoodsList', data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.checked = false;
          });
          this.list = list;
        });
    },
    close() {
      this.$emit('close');
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    submit() {
      this.$emit('checkGoods', this.selection);
      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 20px 0;
  box-sizing: border-box;
}
.list-box {
  height: 400px;
  overflow: auto;
  margin-top: 15px;
  & > div {
    margin-bottom: 10px;
  }
  img {
    height: 70px;
    width: auto;
    margin: 0 15px;
  }
}
.table_list {
  border: solid 1px #c9cbd6;
  margin-top: 20px;
  height: 500px;
  overflow-y: scroll;
}
</style>
